/* eslint-disable max-statements */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable complexity */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable no-console */
/* eslint-disable react/prop-types */
import {SelectField, Option, FormControl, InputLabel} from '@deere/fuel-react';
import {useSelector, useDispatch} from 'react-redux';
import {useEffect, useState} from 'react';
import {setSelectedValue, setSelectedAppName} from '../../redux/features/select/select.slice';
import {Controller, useForm} from 'react-hook-form';

export const ContactUsSelectField = ({
    label, register, errors, appId, setValue
}) => {
    const dispatch = useDispatch();
    const apps = useSelector((state) => state.app.apps);
    const [jdsnApps, setJdsnApps] = useState([]);
    const [appName, setAppName] = useState('');
    const {control} = useForm();

    const findAppName = (paramAppId, dbApps) => {
        const appOption = dbApps.find((app) => app.appId.trim().toUpperCase() === paramAppId.trim().toUpperCase());

        if (appOption) {
            setValue('jdsnAppSelection', appOption.appName.trim().toUpperCase());
            setJdsnApps(dbApps);
            setAppName(appOption.appName);
            dispatch(setSelectedValue(appOption.appName.trim().toUpperCase()));
        } else {
            setValue('jdsnAppSelection', '');
        }
    };

    useEffect(() => {
        if (typeof appId === 'string' && appId.trim().length > 0 && Array.isArray(apps) && apps.length > 0 && !appName) {
            findAppName(appId, apps);
        } else if (Array.isArray(apps) && apps.length > 0) {
            setJdsnApps(apps);
        } else {
            setJdsnApps([]);
        }
    }, [appId, apps]);

    const generateSelectOptions = (dbApps) => {
        let options = [];

        if (Array.isArray(dbApps) && dbApps.length > 0) {
            options = dbApps.map((op, index) => {
                return (<Option
                    id={op.appId}
                    key={index}
                    value={op.appId}
                >{op.appName}</Option>);
            });
        }
        options.push(<Option
            disabled
            hidden
            key={''}
            value={''}
        >{'Select...'}</Option>);
        return options;
    };

    const handleChange = async (event) => {
        event.preventDefault();
        const selected = event.target.value ? event.target.value : '';
        const appOption = jdsnApps.find((app) => app.appId.trim().toUpperCase() === selected.trim().toUpperCase());

        if (appOption) {
            dispatch(setSelectedAppName(appOption.appName));
        }
        setAppName(selected);
        dispatch(setSelectedValue(selected));
    };

    return (<FormControl
        fullWidth
        required
    >
        <InputLabel>{label}</InputLabel>
        <Controller
            control={control}
            defaultValue={''}
            name='stackoverflow'
            render={() => {
                return (
                    <SelectField
                        disabled={appId && appId.trim().length > 0}
                        error={errors.jdsnAppSelection?.message}
                        fullWidth
                        helperText={errors.jdsnAppSelection?.message}
                        inputProps={register('jdsnAppSelection')}
                        onChange={handleChange}
                        value={appId && appId.trim().length > 0 ? appId : appName}
                    >{generateSelectOptions(jdsnApps)}</SelectField>
                );
            }
            }
            rules={{
                required: 'Please select a stackoverflow'
            }}
        />
    </FormControl>);
};
